import { Stack } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { BulkCreateTransactions } from '~/features/common/Balance/BalanceHistory/BulkCreateTransactions'
import { Balance } from '~/shared/api'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { FileExportLink } from '~/shared/ui/FileExport/FileExportLink'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'

const title = 'bulk transaction creation'

const breadcrumbs: BreadcrumbsList = [
  {
    titleI18n: 'balances',
    link: '/balance/balance-histories',
  },
  {
    titleI18n: title,
  },
]

function BulkCreateTransactionsPage() {
  const { t } = useTranslation()
  return (
    <PageContainer title={t(title)}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <Stack direction='row' justifyContent='space-between'>
          <PageTitle>{t(title)}</PageTitle>
          <FileExportLink
            title={t('button.download template')}
            fnGetLink={Balance.getMassImportTemplate}
          />
        </Stack>
      </Container>

      <BulkCreateTransactions />
    </PageContainer>
  )
}

export default BulkCreateTransactionsPage
